export default __webpack_public_path__ + "static/media/img1.1da76b57.jpg";